<template>
  <div class="page" v-loading="loading">
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="用户名">
            <el-input v-model="searchData.UserName" placeholder="请输入用户名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="账号">
            <el-input v-model="searchData.Phone" placeholder="请输入账号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%"
      border>
      <!--          <el-table-column type="selection"  fixed align="center"></el-table-column>-->
      <el-table-column prop="userName" label="用户名称" align="center"></el-table-column>
      <el-table-column prop="accountNo" label="登录账号" align="center"></el-table-column>
      <el-table-column label="地区" align="center">
        <template slot-scope="scope">
          {{ scope.row.provinceName }},{{ scope.row.cityName }},{{ scope.row.districtName }}
        </template>
      </el-table-column>
      <el-table-column prop="platformName" label="平台" align="center"></el-table-column>
      <el-table-column label="付费会员" align="center">
        <template slot-scope="scope">
          {{ scope.row.payingMember ? '已付费' : '未付费' }}
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="会员等级" align="center">
        <template slot-scope="scope">
          {{ scope.row.memberLevelStr ? scope.row.memberLevelStr : '暂无会员信息' }}
        </template>
      </el-table-column>
      <el-table-column prop="regtime" label="注册时间" align="center"></el-table-column>
      <el-table-column prop="payTime" label="付费时间" align="center"></el-table-column>
      <el-table-column prop="accountStateStr" label="账号状态" align="center"></el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
    </el-pagination>
  </div>
</template>

<script>
import { GetKSAXSupplierUsers } from "../../../api/api";
export default {
  name: "Index",
  data() {
    return {
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        UserName: '',
        Phone: ''
      },
      loading: false,
      tableList: [],
      total: null,
    }
  },
  created() {
    this.getTableList();
  },
  methods: {
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    searchFun() {
      this.PageIndex = 1;
      this.getTableList();
    },
    resetFun() {
      this.searchData.UserName = '';
      this.searchData.Phone = '';
      this.getTableList();
    },
    async getTableList(searchData) {
      this.loading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.PageSize;
      let res = await GetKSAXSupplierUsers(this.searchData);
      setTimeout(() => {
        this.loading = false;
      }, 500)
      if (res.data.success) {
        this.total = res.data.result.data.dataCount;
        this.tableList = res.data.result.data.data;
      } else {
        this.$message.error(res.data.msg)
      }
      console.log('axiu用户列表', res);
    },
  }
}
</script>

<style scoped>
</style>
